export default function TextField() {
  return {
    MuiTextField: {
      defaultProps: {
        size: 'small',
      },
    },
  };
}
